import { render, staticRenderFns } from "./conservante.vue?vue&type=template&id=0a55fc39&"
import script from "./conservante.vue?vue&type=script&lang=js&"
export * from "./conservante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports